import { Injectable } from '@angular/core';
import { Estimate } from '../../domain/models/estimate.model';
import { EstimateDto } from '../dtos/estimate.dto';

@Injectable()
export class EstimateMapper {
  public toEstimate(dto: EstimateDto): Estimate {
    return {
      externalId: dto.ExternalId,
      externalUrl: dto.ExternalUrl,
      title: dto.Title,
      clientId: dto.ClientId,
      clientName: dto.ClientName,
      patientIds: dto.PatientIds ?? [],
      patientNames: dto.PatientNames ?? [],
      consultationId: dto.ConsultationId,
      consultationDate: dto.ConsultationDate,
      consultationReason: dto.ConsultationReason,
      departmentId: dto.DepartmentId,
      departmentName: dto.DepartmentName,
      veterinarianId: dto.VeterinarianId,
      veterinarianName: dto.VeterinarianName,
      status: dto.Status,
      archived: dto.Archived,
      subtotal: dto.Subtotal,
      vat: dto.Vat,
      total: dto.Total,
      minSubtotal: dto.MinSubtotal,
      minVat: dto.MinVat,
      minTotal: dto.MinTotal,
      maxSubtotal: dto.MaxSubtotal,
      maxVat: dto.MaxVat,
      maxTotal: dto.MaxTotal,
      notes: dto.Notes,
      notesPdf: dto.NotesPdf,
      createdAtUtc: dto.Created,
      modifiedAtUtc: dto.Modified,
    };
  }
}
